import { confirmedStories } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

export default function ConfirmedStories() {
  return (
    <section id="stories" className="w-full scroll-mt-20 bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="实锤现场"
        title="有材料、有时间线的，才敢叫做实锤"
        desc="每条内容都附上可核对的线索与出处说明，黑料学生实锤优先展示证据链完整的事件。"
        action={{ label: "进入实锤栏目", href: "#stories" }}
      />

      <div className="grid gap-4 md:grid-cols-3 md:gap-5">
        {confirmedStories.map((story) => (
          <article
            key={story.id}
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
          >
            <div className="relative h-[180px] w-full overflow-hidden md:h-[200px]">
              <img
                src={story.cover}
                alt={`黑料学生实锤封面：${story.title}`}
                title={`${story.title} - 黑料学生实锤`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-foreground-950">
                <i className="ri-shield-star-line"></i>
                {story.tag}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-[15px] font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {story.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{story.summary}</p>
              <div className="mt-3.5 flex items-center justify-between border-t border-background-200/70 pt-3 text-[11px] text-foreground-400">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </span>
                  {story.time}
                </span>
                <span className="flex cursor-pointer items-center gap-0.5 text-primary-600">
                  查看
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-arrow-right-s-line text-base"></i>
                  </span>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}